import { PlantitaMark } from "@/app/components/auth/PlantitaMark";

/** Logo mark, app name, and tagline for auth screens. */
export function AuthBrand() {
  return (
    <div className="flex items-center gap-3 mb-10">
      <PlantitaMark />
      <div className="min-w-0">
        <p className="m-0 font-display font-medium text-[18px] tracking-tight text-ink leading-none">
          Plantita
        </p>
        <p className="m-0 mt-1 font-sans text-[12.5px] text-ink-3 leading-none">
          A garden, well-tended.
        </p>
      </div>
    </div>
  );
}
